import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Module } from 'src/app/models/module';
import { UploadIds } from 'src/app/models/upload';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class ModuleService {
  getModulesInSelectedIntervention(studyId: number, interventionId: number): Observable<Module[]> {
    return this.apiService.get<Module[]>(`/dashboard/study/${studyId}/intervention/${interventionId}/module`);
  }

  getModuleById(studyId: number, moduleId: number): Observable<Module> {
    return this.apiService.get<Module>(`/dashboard/study/${studyId}/module/${moduleId}`);
  }

  createModule(module: Module & { study_id: number }): Observable<Module> {
    return this.apiService.post<Module>(`/dashboard/study/${module.study_id}/module`, module);
  }

  updateModule(module: Module & { study_id: number }): Observable<Module> {
    return this.apiService.put<Module>(`/dashboard/study/${module.study_id}/module/${module.id}`, module);
  }

  duplicateModule(module: Module & { study_id: number }): Observable<Module> {
    return this.apiService.post<Module>(`/dashboard/study/${module.study_id}/module/${module.id}`, null);
  }

  deleteModule(module: Module & { study_id: number }): Observable<void> {
    return this.apiService.delete<void>(`/dashboard/study/${module.study_id}/module/${module.id}`);
  }

  uploadModuleImage(imageFile: File, idsForUpload: UploadIds): Observable<HttpEvent<string[]>> {
    const body: FormData = new FormData();
    body.append('uploads[]', imageFile, imageFile.name);
    return this.apiService.post<HttpEvent<string[]>>(
      `/dashboard/study/${idsForUpload?.studyId || 0}/module/${idsForUpload?.moduleId || 0}/upload`,
      body,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }

  exportModuleToCSV(module: Module): Observable<any> {
    return this.apiService.get(
      `/export/study/${module.studyId}/module/${module.id}`,
      { responseType: 'text/csv' }
    );
  }

  constructor(private apiService: ApiService) {}
}
